// Indikator kecil "AI sedang disiapkan" saat backend Space dibangunkan setelah
// login (keputusan Andra 29 Okt 2026, #1057). Muncul selama status 'warming'
// dan hilang begitu siap (atau waktu habis). Ringan, tanpa polling sendiri.

import { useEffect, useState } from 'react';
import { subscribeAiWake } from '../lib/hfWake';
import { useApp } from '../contexts/AppContext';

const AiWakeIndicator = () => {
  const { lang } = useApp();
  const [status, setStatus] = useState('idle');

  useEffect(() => subscribeAiWake(setStatus), []);

  if (status !== 'warming') return null;

  return (
    <div
      className="fixed bottom-4 right-4 z-[70] flex items-center gap-2 px-3 py-2 rounded-xl font-mono"
      style={{
        background: 'rgba(2,6,14,0.92)',
        border: '1px solid rgba(255,214,10,0.4)',
        boxShadow: '0 8px 24px rgba(0,0,0,0.4)',
        backdropFilter: 'blur(10px)',
      }}
      role="status"
      aria-live="polite"
    >
      <span className="inline-block w-2 h-2 rounded-full animate-blink" style={{ background: '#ffd60a' }} />
      <span className="text-[10px] font-black tracking-wide" style={{ color: '#ffd60a' }}>
        {lang === 'en' ? 'AI IS BEING PREPARED' : 'AI SEDANG DISIAPKAN'}
      </span>
    </div>
  );
};

export default AiWakeIndicator;
